<template>
	<div class="w1200">
		<el-tabs :tab-position="tabPosition" @tab-click="newsListcontent(id)">
			<el-tab-pane :label="item.title" v-for="(item, index) in nav"  class="nav-item"  :key="index">

				<div class="item" v-for="(item, index) in newListcontent">
					<div class="img" v-if="item.img!=''">
						<a :href="'#/NewSInfo/' + item.id " target="_blank"><img :src="item.img" width="160" height="100" /></a>
					</div>
					<div class="txt">
						<div class="name">
							<a :href="'#/NewSInfo/' + item.id " target="_blank">{{item.title}}</a>
						</div>
						<div class="info">
							<span class="industry" v-if="item.group_id == 1">{{item.group_name}}</span>
							<span class="international" v-if="item.group_id == 2">{{item.group_name}}</span>
							<span class="association" v-if="item.group_id == 3">{{item.group_name}}</span>
							<i class="date">{{item.create_time | formatDate}}</i>
						</div>
					</div>
				</div>

			</el-tab-pane>

		</el-tabs>
	</div>

</template>

<script>
	import Vue from 'vue';
	import Element from 'element-ui';
	import { formatDate } from '../assets/js/date.js';
	export default {
		filters: { //格式化日期
			formatDate(time) {
				var date = new Date(time);
				return formatDate(date, 'yyyy-MM-dd hh:mm');
			}
		},
		data() {
			return {
				path: domain.apiUrl,
				newListcontent: {},
				current: 1, //当前页码
				pages: 1, //总页数
				size: 8, //每页条数
				total: 0, //总条数
				paginationShow: false, //是否显示分页
				id: 0,
				tabPosition: 'left',
				nav: [{
						title: '首页',
					},
					{
						title: '关于协会',
					},
					{
						title: '协会信息',
					},

				],
				navIndex: 0,
			};
		},
		created() {
			this.newsListId();
		},
		methods: {

			/*	//改变每页显示数量时调用
				handleSizeChange(val) {
					this.$nextTick(() =>
						this.newsListId(),
					)
				},
				//点击下一页和点击页码时执行
				handleCurrentChange(val) {
					this.newsListId();
				},*/
			//带参数接口
			
			newsListId() {
				var id = this.$route.params.id;
				this.id = id;
				console.log(id);
				this.$http.post(this.path + "index/getNewsListPage?currentPage=" + this.current + "&size=" + this.size + "&groupId=" + id).then(function(response) {
					if(response.status === 200) {
						var data = response.body;
						this.newListcontent = data.records;
						/*	this.pages = data.pages;//设置分页的总页数
          				this.total = data.total;//设置数据总条数
          				if (this.total > 1) {//总页数大于1时显示分页
				            this.paginationShow = true;
				          }*/
					}
				})
			},
			newsListcontent(id) {
				console.log(888);
				this.$http.post(this.path + "index/getNewsListPage?currentPage=" + this.current + "&size=" + this.size + "&groupId=" + id).then(function(response) {
					if(response.status === 200) {
						var data = response.body;
						this.newListcontent = data.records;
						console.log(this.newListcontent);
					/*	this.pages = data.pages;//设置分页的总页数
          				this.total = data.total;//设置数据总条数
          				if (this.total > 1) {//总页数大于1时显示分页
				            this.paginationShow = true;
				          }*/
					}
				})
			},

		}
	};
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/NewsList2.vue